import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from 'components/common/Elements/Elements';
import LoginHeader from '../LoginHeader/LoginHeader';

import { useAuth } from '../../../hooks/useAuth';
import { CustomIcon } from '@p81-common/ui';
import { env } from '../../../env';

import classes from './Login.module.scss';

const Login: React.FC = () => {
  const { error: authError, isLoading, login } = useAuth();
  const [error, setError] = useState<string>('');

  const { t } = useTranslation('activity');

  // Handle authentication errors
  useEffect(() => {
    if (authError) {
      setError(authError);
    }
  }, [authError]);

  return (
    <section className={classes.login}>
      <LoginHeader text={t('activity:login.TITLE')} />

      {(error || authError) && (
        <Text className={classes.login_errorMessage}>{error || authError}</Text>
      )}

      <button
        className={classes.azureLoginButton}
        onClick={() => login()}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <div className={classes.spinner}>
              <div className={classes.spinnerCircle}></div>
            </div>
          </>
        ) : (
          <CustomIcon
            className={classes.azureLoginButton_icon}
            src={`${env.REACT_APP_STATIC_ASSETS_URL}/icons/azure.svg`}
            customSize={16}
          />
        )}
        {t('activity:login.MICROSOFT')}
      </button>
    </section>
  );
};

export default Login;
